import React from "react";

const Home = () => {
    return (
        <div className="text-center">
            {/* <h2>Powerfront Scheduling Module</h2> */}
        </div>
    );
}

export default Home;